import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getIsIslamicBanking } from "../../store/selectors/appConfig";
import { getIsEditableStatusSearchInfo } from "../../store/selectors/searchProspect";

import routes, { agentBaseName } from "../../routes";
import { STANDART, ISLAMIC, NONE, AGENT } from "./constants";

export const useBlobColor = (isHideSideBar = false) => {
  const { pathname } = useLocation();
  const isIslamicBanking = useSelector(getIsIslamicBanking);
  const isComeFromROScreens = useSelector(getIsEditableStatusSearchInfo);
  const isfinanceProductComparison = routes.financeProductComparison === pathname;
  const isAgentPages =
    agentBaseName.split("/")[1] === pathname.split("/")[1] || isComeFromROScreens;

  if (isHideSideBar) return NONE;
  if (isAgentPages) return AGENT;
  if (!isfinanceProductComparison && isIslamicBanking) return ISLAMIC;
  return STANDART;
};
